import React from "react";
import { CheckCircle, Camera, UploadCloud, Download, AlertCircle } from "lucide-react";

const HomeContent = () => {
  return (
    <div className="max-w-6xl mx-auto px-4 py-12 text-slate-800 space-y-10 font-sans">
      
      {/* 1. Hero Content / Introduction */}
      <section className="bg-white/70 backdrop-blur-lg border border-white/20 rounded-3xl p-8 shadow-xl shadow-blue-500/5">
        <h2 className="text-3xl font-bold text-gray-900 mb-4 flex items-center gap-2">
          What is a Passport Size Photo?
        </h2>
        <div className="grid md:grid-cols-2 gap-8 items-center">
          <div className="space-y-4">
            <p className="text-lg leading-relaxed text-slate-600">
              A passport size photo is a standardized photograph required for official documents such as passports, visas, and ID cards. These photos must follow strict rules related to size, background, and lighting.
            </p>
            <div className="bg-blue-50 border-l-4 border-blue-500 p-4 rounded-r-xl">
              <p className="text-blue-800 font-medium">
                In India, the standard size is 35mm x 45mm with a plain white background.
              </p>
            </div>
          </div>
          <div className="bg-slate-100 rounded-2xl h-48 flex items-center justify-center border-2 border-dashed border-slate-300">
             {/* Placeholder for an illustrative graphic */}
             <span className="text-slate-400 italic">Official Dimensions Graphic</span>
          </div>
        </div>
      </section>

      {/* 2. Visual Step Guide (Highly recommended for AdSense "Utility" value) */}
      <div className="grid md:grid-cols-4 gap-4 text-center">
        {[
          { icon: <UploadCloud className="mx-auto mb-2 text-blue-600" />, title: "Upload", desc: "Select your photo" },
          { icon: <Camera className="mx-auto mb-2 text-indigo-600" />, title: "AI Process", desc: "Background removal" },
          { icon: <CheckCircle className="mx-auto mb-2 text-green-600" />, title: "Easy to use", desc: "See guidelines" },
          { icon: <Download className="mx-auto mb-2 text-purple-600" />, title: "Download", desc: "Ready to print" }
        ].map((step, i) => (
          <div key={i} className="bg-white p-6 rounded-2xl shadow-sm border border-slate-100">
            {step.icon}
            <h4 className="font-bold text-slate-900">{step.title}</h4>
            <p className="text-sm text-slate-500">{step.desc}</p>
          </div>
        ))}
      </div>

      {/* 3. Detailed Guidelines Section */}
      <div className="grid md:grid-cols-2 gap-6">
        <section className="bg-white/80 rounded-2xl p-6 shadow-md border border-slate-50">
          <h2 className="text-xl font-bold mb-4 text-slate-900">India Specific Requirements</h2>
          <ul className="space-y-3">
            <li className="flex gap-2">
              <div className="h-5 w-5 rounded-full bg-green-100 text-green-600 flex items-center justify-center text-xs">✓</div>
              <p className="text-sm">Face must cover 70–80% of the photo area.</p>
            </li>
            <li className="flex gap-2">
              <div className="h-5 w-5 rounded-full bg-green-100 text-green-600 flex items-center justify-center text-xs">✓</div>
              <p className="text-sm">Neutral expression: No smiling, no teeth visible.</p>
            </li>
            <li className="flex gap-2">
              <div className="h-5 w-5 rounded-full bg-green-100 text-green-600 flex items-center justify-center text-xs">✓</div>
              <p className="text-sm">Eyes open and clearly visible (no glare on glasses).</p>
            </li>
          </ul>
        </section>

        <section className="bg-red-50/50 rounded-2xl p-6 shadow-md border border-red-100">
          <h2 className="text-xl font-bold mb-4 text-red-900 flex items-center gap-2">
            <AlertCircle size={20}/> Mistakes to Avoid
          </h2>
          <ul className="space-y-3 text-red-800">
            <li className="text-sm">• Shadows on the background or face.</li>
            <li className="text-sm">• Wearing uniforms, hats, or headbands.</li>
            <li className="text-sm">• Low-resolution or "selfie" style angles.</li>
          </ul>
        </section>
      </div>

      {/* 4. FAQ Section */}
{ /*<section className="bg-slate-900 text-white rounded-3xl p-8 shadow-2xl">
        <h2 className="text-2xl font-bold mb-8 text-center">Frequently Asked Questions</h2>
        <div className="grid md:grid-cols-2 gap-6">
          {[
            { q: "Can I use a phone selfie?", a: "Yes, as long as it's high resolution and shot at eye level against a plain wall." },
            { q: "Is the background removal accurate?", a: "Our AI is trained specifically for hair and edge detection to meet official standards." },
            { q: "Which format will I get?", a: "You can download in JPEG or PNG, ready for high-quality printing." },
            { q: "Is this service free?", a: "Yes, our basic AI passport photo generator is free for all users." }
          ].map((item, i) => (
            <div key={i} className="border-b border-slate-700 pb-4">
              <p className="font-semibold text-blue-400 mb-1">Q: {item.q}</p>
              <p className="text-slate-400 text-sm leading-relaxed">{item.a}</p>
            </div>
          ))}
        </div>
      </section>*/}

    </div>
  );
};

export default HomeContent;
          
